<script setup lang="ts">
import { computed } from "vue";

import SVGWrapper from "./utils/SVGWrapper.vue";

import type { colorTag } from "@/Modules/App/Models/Styles/Colors";
import type { iconSize } from "@/Modules/App/Models/Styles/Icons";

export interface IconProps {
  size?: iconSize;
  color?: colorTag;
  background?: colorTag;
}

const props = withDefaults(defineProps<IconProps>(), { color: "content-high", size: "md" });

const colorClass = computed((): string => `fill-${props.color}`);
</script>

<template>
  <SVGWrapper :size="size" :background="background" viewBox="0 0 15 18">
    <g clip-path="url(#clip0_6892_8988)">
      <path
        d="M5.50395 1.99308H1.40204V3.55017H5.51881C5.84577 4.70242 6.84153 5.54325 8.04535 5.54325C9.24917 5.54325 10.2449 4.70242 10.5719 3.55017H14.7778V1.99308H10.5719C10.2449 0.84083 9.24917 0 8.04535 0C6.84153 0 5.84577 0.84083 5.51881 1.99308H5.50395ZM9.18972 2.77163C9.18972 3.44118 8.66955 3.98616 8.03049 3.98616C7.39142 3.98616 6.87125 3.44118 6.87125 2.77163C6.87125 2.10208 7.39142 1.55709 8.03049 1.55709C8.66955 1.55709 9.18972 2.10208 9.18972 2.77163ZM8.65469 8.22145H1.40204V9.77855H8.66955C8.99652 10.9308 9.99227 11.7716 11.1961 11.7716C12.3999 11.7716 13.3957 10.9308 13.7226 9.77855H14.763V8.22145H13.7226C13.3957 7.0692 12.3999 6.22837 11.1961 6.22837C9.99227 6.22837 8.99652 7.0692 8.66955 8.22145H8.65469ZM12.3405 9C12.3405 9.66955 11.8203 10.2145 11.1812 10.2145C10.5422 10.2145 10.022 9.66955 10.022 9C10.022 8.33045 10.5422 7.78547 11.1812 7.78547C11.8203 7.78547 12.3405 8.33045 12.3405 9ZM0.777832 15.2284C0.777832 16.7543 1.96679 18 3.42327 18C4.62709 18 5.62284 17.1592 5.94981 16.0069H14.763V14.4498H5.94981C5.62284 13.2976 4.62709 12.4567 3.42327 12.4567C1.96679 12.4567 0.777832 13.7024 0.777832 15.2284ZM4.5825 15.2284C4.5825 15.8979 4.06233 16.4429 3.42327 16.4429C2.7842 16.4429 2.26403 15.8979 2.26403 15.2284C2.26403 14.5588 2.7842 14.0138 3.42327 14.0138C4.06233 14.0138 4.5825 14.5588 4.5825 15.2284Z"
        :class="colorClass"
      />
    </g>
    <defs>
      <clipPath id="clip0_6892_8988">
        <rect width="14" height="18" fill="white" transform="translate(0.777832)" />
      </clipPath>
    </defs>
  </SVGWrapper>
</template>

<style scoped lang="scss"></style>
